/**
 * Offices whose claims come from a partner feed instead of an Amadeus PNR (no AI
 * study possible, e-tickets shown inline). Digitrips only for now — widen to other
 * `*_PASSIVE_OFFICE` partners once their feeds register tickets too.
 */
export function isPartnerFeedOffice(amadeusOfficeId: string | null | undefined): boolean {
  return amadeusOfficeId === "DIGITRIPS_PASSIVE_OFFICE";
}
